<template>
	<div class="palco-page" style="position: relative;">
		<div class="palco-header">
			<div class="container">
				<div class="header-row">
					<div class="header-tipo">
						<span>{{ espectaculo.tipoNombre }}</span>
					</div>
				</div>
				<div class="header-row" v-if="espectaculo.requiereInstituciones">
					<div class="header-equipos">
						<div class="header-equipo header-equipo-local">
							<img :src="espectaculo.institucionLocalEscudo" :alt="espectaculo.institucionLocalNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionLocalNombre }}</span>
							<span class="vs">vs</span>
						</div>
						<div class="header-equipo header-equipo-visitante">
							<img :src="espectaculo.institucionVisitanteEscudo" :alt="espectaculo.institucionVisitanteNombre" class="header-escudo" />
							<span>{{ espectaculo.institucionVisitanteNombre }}</span>
						</div>
					</div>
				</div>
				<div v-else>
					{{ espectaculo.nombre }}
				</div>
			</div>
		</div>
		<div class="palco-main">
			<div class="container">
				<div class="palco-left">
					<h1 v-if="isPalco">Palco {{ palco.SectorDescripcion }}</h1>
					<h1 v-else>Paddock {{ palco.SectorDescripcion }}</h1>
					<p v-if="isPalco">Completá los datos para la invitación a palcos</p>
					<p v-else>Completá los datos para la invitación a paddocks</p>
					<div class="info-palquistas" v-if="espectaculo.descripcionPalcos && isPalco">
						<span class="info-palquistas-title">Información para palquistas</span>
						<span class="info-palquistas-text" v-html="espectaculo.descripcionPalcos"></span>
					</div>
					<div class="info-palquistas" v-if="espectaculo.descripcionPaddock && !isPalco">
						<span class="info-palquistas-title">Información para paddocks</span>
						<span class="info-palquistas-text" v-html="espectaculo.descripcionPaddock"></span>
					</div>
					<div class="archivos-content" v-if="espectaculoArchivos.length > 0">
						<span class="title">Archivos</span>
						<div class="archivos" :class="descargandoArchivo ? 'esconder-archivos' : ''">
							<div class="archivo" v-for="archivo in espectaculoArchivos" :key="archivo.EspectaculoArchivoId" @click.prevent="descargarArchivo(archivo.EspectaculoArchivoId)">
								<div class="archivo-left">
									<img :src="archivo.ArchivoTipoIcono" :alt="archivo.ArchivoTipoNombre">
								</div>
								<div class="archivo-right">
									<span class="archivo-nombre">{{ archivo.EspectaculoArchivoNombre }}</span>
									<span class="archivo-extension">{{ archivo.ArchivoTipoExtension }}</span>
								</div>
							</div>
							<div class="archivo-descargando" v-if="descargandoArchivo">
								<clip-loader color="#dddddd" size="24px"></clip-loader>
							</div>
							<a class="descargar-archivo" :href="base64" :download="fileName" style="display: none;"></a>
						</div>
					</div>
					<div class="tickets" v-if="Number(palco.EspectaculoSectorSNDisponibilidad) > 0 && permitirCanje">
						<div class="ticket" :id="'tn' + t.ticketNum" v-for="t in tickets" :key="t.ticketNum" >
							<div class="palco-row" v-if="preselecciones.length > 0">
								<button class="btn-preseleccion" v-if="isPalco" @click="showPreselecciones(t.ticketNum, false)"><users-icon></users-icon>Preseleccionar palquista</button>
								<button class="btn-preseleccion" v-else @click="showPreselecciones(t.ticketNum, false)"><users-icon></users-icon>Preseleccionar persona</button>
							</div>
							<div class="palco-row">
								<div class="input-group">
									<label :for="'ticket-nombre-' + t.ticketNum">Nombres</label>
									<input type="text" name="ticket-nombre" :id="'ticket-nombre-' + t.ticketNum" v-model="t.ticketNombre">
								</div>
								<div class="input-group">
									<label :for="'ticket-apellido-' + t.ticketNum">Apellidos</label>
									<input type="text" name="ticket-apellido" :id="'ticket-apellido-' + t.ticketNum" v-model="t.ticketApellido">
								</div>
							</div>
							<div class="palco-row">
								<div class="input-group">
									<label :for="'ticket-tipoDocumento-' + t.ticketNum">Tipo de documento</label>
									<multiselect name="tipoDocumento" :id="'ticket-tipoDocumento-' + t.ticketNum" v-model="t.ticketDocumentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label :for="'ticket-documento-' + t.ticketNum">Documento</label>
									<input type="text" name="ticket-documento" :id="'ticket-documento-' + t.ticketNum" v-model="t.ticketDocumento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<!-- <div class="palco-row">
								<div class="input-group">
									<label :for="'ticket-telefono-' + t.ticketNum">Teléfono</label>
									<input type="text" name="ticket-telefono" :id="'ticket-telefono-' + t.ticketNum" v-model="t.ticketTelefono" @keypress="soloNumeros">
								</div>
								<div class="input-group">
									<span class="small-text">Por disposición del MSP, es obligatorio ingresar el número de teléfono del espectador</span>
								</div>
							</div> -->
							<div class="palco-row row-complemento">
								<div class="input-group" v-for="(complemento, index) in datosComplementarios" :key="complemento.ComplementoId">
									<label :for="complemento.ComplementoId">{{ complemento.ComplementoNombre }}</label>
									<input :name="complemento.ComplementoId" :id="complemento.ComplementoId" type="text" v-model="t.datosComplementarios[index].Valor" v-if="complemento.ComplementoTipo !== 'O'">
									<multiselect v-else :name="complemento.ComplementoId" :id="complemento.ComplementoId" v-model="t.datosComplementarios[index].Valor" :options="datosComplementarios[index].Opciones" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontraron resultados.</span>
										<span slot="noOptions">No se encontraron resultados.</span>
									</multiselect>
								</div>
							</div>
							<div class="palco-row">
								<div class="palco-ubicacion">
									<div class="palco-ubicacion-item">
										<span class="palco-ubicacion-title">Tribuna</span>
										<span class="palco-ubicacion-valor">{{ palco.TribunaNombre.replace('Palcos ', '') }}</span>
									</div>
									<div class="palco-ubicacion-item">
										<span v-if="isPalco" class="palco-ubicacion-title">Palco</span>
										<span v-else class="palco-ubicacion-title">Paddock</span>
										<span class="palco-ubicacion-valor">{{ palco.SectorDescripcion.replace('Palco ', '') }}</span>
									</div>
									<div class="palco-ubicacion-item" v-if="isPalco">
										<span class="palco-ubicacion-title">Piso</span>
										<span class="palco-ubicacion-valor">{{ palco.PalcoNivel }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tickets tickets-menores" v-if="Number(palco.PalcoMenoresDisponibilidad) > 0 && permitirCanje">
						<span class="tickets-menores-title">Socios menores (entre 6 y 11 años inclusive)</span>
						<div class="ticket" :id="'tn' + t.ticketNum" v-for="t in ticketsMenores" :key="t.ticketNum" >
							<div class="palco-row" v-if="preselecciones.length > 0">
								<button class="btn-preseleccion" v-if="isPalco" @click="showPreselecciones(t.ticketNum, true)"><users-icon></users-icon>Preseleccionar palquista</button>
								<button class="btn-preseleccion" v-else @click="showPreselecciones(t.ticketNum, true)"><users-icon></users-icon>Preseleccionar persona</button>
							</div>
							<div class="palco-row">
								<div class="input-group">
									<label :for="'ticket-nombre-' + t.ticketNum">Nombres</label>
									<input type="text" name="ticket-nombre" :id="'ticket-nombre-' + t.ticketNum" v-model="t.ticketNombre">
								</div>
								<div class="input-group">
									<label :for="'ticket-apellido-' + t.ticketNum">Apellidos</label>
									<input type="text" name="ticket-apellido" :id="'ticket-apellido-' + t.ticketNum" v-model="t.ticketApellido">
								</div>
							</div>
							<div class="palco-row">
								<div class="input-group">
									<label :for="'ticket-tipoDocumento-' + t.ticketNum">Tipo de documento</label>
									<multiselect name="tipoDocumento" :id="'ticket-tipoDocumento-' + t.ticketNum" v-model="t.ticketDocumentoTipo" :options="tipoDocumentos" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="false">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontró tipo.</span>
										<span slot="noOptions">No hay tipos de documentos disponibles.</span>
									</multiselect>
								</div>
								<div class="input-group">
									<label :for="'ticket-documento-' + t.ticketNum">Documento</label>
									<input type="text" name="ticket-documento" :id="'ticket-documento-' + t.ticketNum" v-model="t.ticketDocumento" placeholder="Sin puntos ni guiones. Ej: 12345678">
								</div>
							</div>
							<div class="palco-row row-complemento">
								<div class="input-group" v-for="(complemento, index) in datosComplementarios" :key="complemento.ComplementoId">
									<label :for="complemento.ComplementoId">{{ complemento.ComplementoNombre }}</label>
									<input :name="complemento.ComplementoId" :id="complemento.ComplementoId" type="text" v-model="t.datosComplementarios[index].Valor" v-if="complemento.ComplementoTipo !== 'O'">
									<multiselect v-else :name="complemento.ComplementoId" :id="complemento.ComplementoId" v-model="t.datosComplementarios[index].Valor" :options="datosComplementarios[index].Opciones" track-by="descripcion" label="descripcion" :searchable="false" :close-on-select="true" :show-labels="false" placeholder="" :allow-empty="true">
										<template slot="singleLabel" slot-scope="{ option }"><strong>{{ option.descripcion }}</strong></template>
										<span slot="noResult">No se encontraron resultados.</span>
										<span slot="noOptions">No se encontraron resultados.</span>
									</multiselect>
								</div>
							</div>
							<div class="palco-row">
								<div class="palco-ubicacion">
									<div class="palco-ubicacion-item">
										<span class="palco-ubicacion-title">Tribuna</span>
										<span class="palco-ubicacion-valor">{{ palco.TribunaNombre.replace('Palcos ', '') }}</span>
									</div>
									<div class="palco-ubicacion-item">
										<span v-if="isPalco" class="palco-ubicacion-title">Palco</span>
										<span v-else class="palco-ubicacion-title">Paddock</span>
										<span class="palco-ubicacion-valor">{{ palco.SectorDescripcion.replace('Palco ', '') }}</span>
									</div>
									<div class="palco-ubicacion-item" v-if="isPalco">
										<span class="palco-ubicacion-title">Piso</span>
										<span class="palco-ubicacion-valor">{{ palco.PalcoNivel }}</span>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div class="tickets-canjear" v-if="(Number(palco.EspectaculoSectorSNDisponibilidad) > 0 || Number(palco.PalcoMenoresDisponibilidad) > 0) && permitirCanje">
						<button class="btn" @click="canjearPalcos">Canjear Invitaciones</button>
					</div>
					<!-- <div class="tickets tickets-emitidos" v-if="Number(palco.EspectaculoSectorSNDisponibilidad) < Number(palco.EspectaculoSectorCapacidad)"> -->
					<div class="tickets tickets-emitidos" v-if="ticketsEmitidos.length > 0">
						<span class="tickets-emitidos-title">Tickets ya emitidos</span>
						<div class="ticket" v-for="c in ticketsEmitidos" :key="c.TicketId">
							<div class="palco-row">
								<div class="input-group">
									<label>Nombres</label>
									<span>{{ c.PersonaNombre }}</span>
								</div>
								<div class="input-group">
									<label>Apellidos</label>
									<span>{{ c.PersonaApellido }}</span>
								</div>
								<a class="descargar-ticket" :href="c.TicketURLS3" target="_blank" v-if="c.TicketGeneradoEnS3">
									<download-icon></download-icon>Descargar
								</a>
								<div class="generando-ticket" v-else>
									<loader-icon></loader-icon>
									<span>Generando ticket.</span>
								</div>
							</div>
							<div class="palco-row">
								<div class="input-group">
									<label>Tipo de documento</label>
									<span>{{ c.PersonaDocumentoTipoNombre }}</span>
								</div>
								<div class="input-group">
									<label>Documento</label>
									<span>{{ c.PersonaDocumento }}</span>
								</div>
							</div>
							<!-- <div class="palco-row">
								<div class="input-group">
									<label>Teléfono</label>
									<span>{{ c.PersonaTelefono }}</span>
								</div>
							</div> -->
							<!-- <div class="palco-row">
								<div class="cancelar-ticket" @click.prevent="showModalCancelarTicket(c.TicketId)" target="_blank" v-if="c.IsCancelable && !isCancelandoTicket">
									<x-icon></x-icon>Cancelar ticket
								</div>
								<div class="cancelar-ticket cancelando" v-if="isCancelandoTicket">
									<loader-icon></loader-icon>
									<span>Cancelando ticket</span>
								</div>
							</div> -->
							<!-- <div class="palco-row">
								<div class="palco-ubicacion">
									<div class="palco-ubicacion-item">
										<span class="palco-ubicacion-title">Tribuna</span>
										<span class="palco-ubicacion-valor">{{ c.ticketTribuna }}</span>
									</div>
									<div class="palco-ubicacion-item">
										<span class="palco-ubicacion-title">Palco</span>
										<span class="palco-ubicacion-valor">{{ c.ticketSector }}</span>
									</div>
									<div class="palco-ubicacion-item">
										<span class="palco-ubicacion-title">Piso</span>
										<span class="palco-ubicacion-valor">{{ c.ticketPalcoNivel }}</span>
									</div>
								</div>
							</div> -->
						</div>
					</div>
				</div>
				<div class="palco-right">
					<p>Información del espectáculo</p>
					<div class="palco-right-content">
						<div class="competencia" v-if="espectaculo.mostrarCompetencia">
							<div class="competencia-info">
								<span class="competencia-nombre">{{ espectaculo.competenciaNombre }}</span>
								<span class="competencia-instancia">{{ espectaculo.competenciaInstanciaNombre }}</span>
							</div>
							<img :src="espectaculo.competenciaLogo" :alt="espectaculo.competenciaNombre">
						</div>
						<div class="fecha" v-if="espectaculo.mostrarFecha">
							<span class="fecha-title">Fecha</span>
							<div class="fecha-content">
								<div class="fecha-texto">
									<p>{{ espectaculo.fechaDiaSemanaEscrito }}</p>
									<p>{{ espectaculo.fechaEscrita }}</p>
								</div>
								<div class="fecha-hora">
									{{ espectaculo.hora }}
								</div>
							</div>
						</div>
						<div class="lugar" v-if="espectaculo.mostrarEscenario">
							<span class="lugar-title">Lugar</span>
							<div class="lugar-content">
								<div class="lugar-content-left">
									<div class="lugar-info">
										<span class="lugar-escenario">{{ espectaculo.escenarioNombre }}</span>
										<span class="lugar-direccion">Carlos Anaya 2900</span>
									</div>
									<img :src="espectaculo.escenarioLogo" :alt="espectaculo.escenarioNombre">
								</div>
								<div class="ver-mapa" content="Ver ubicación" v-tippy="{ placement : 'bottom'}" v-if="espectaculo.escenarioMapaURL">
									<a :href="espectaculo.escenarioMapaURL" target="_blank"><map-icon></map-icon></a>
								</div>
							</div>
						</div>
						<div class="descripcion">
							<span class="descripcion-title">Descripción</span>
							<!-- <span class="descripcion-content">{{ espectaculo.descripcion }}</span> -->
							<div class="espectaculo-descripcion" v-html="espectaculo.descripcion"></div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<modal class="promptPreseleccionPalco" name="promptPreseleccionPalco" :clickToClose="false">
			<div class="preseleccion-palco-content">
				<div class="preseleccion-palco-header">
					<div class="preseleccion-header-left">
						<div class="preseleccion-palco-ubicacion">
							<span class="preseleccion-palco-descripcion" v-if="isPalco">Palco {{ palco.SectorDescripcion }}</span>
							<span class="preseleccion-palco-descripcion" v-else>Paddock {{ palco.SectorDescripcion }}</span>
							<span class="preseleccion-palco-tribuna">Elegir preselección</span>
						</div>
					</div>
					<div class="preseleccion-palco-header-cerrar" @click="cerrarPreseleccion()"><x-icon></x-icon></div>
				</div>
				<div class="preseleccion-palco-main" v-if="mostrarPreseleccion">
					<div class="preseleccion-info">
						<span v-if="isPalco">A continuación se listan las personas que Nacional tiene asociadas a tu palco y a aquellas que concurrieron al palco en el último tiempo.</span>
						<span v-else>A continuación se listan las personas que Nacional tiene asociadas a tu paddock y a aquellas que concurrieron al paddock en el último tiempo.</span>
					</div>
					<div class="preseleccion-filtros">
						<span v-if="isPalco">Buscar palquistas</span>
						<span v-else>Buscar personas</span>
						<div class="preseleccion-filtro-row">
							<div class="preseleccion-filtro">
								<input type="text" placeholder="Nombre" v-model="filtrosPreselecciones.nombre">
							</div>
							<div class="preseleccion-filtro">
								<input type="text" placeholder="Documento" v-model="filtrosPreselecciones.documento">
							</div>
						</div>
					</div>
					<div class="preseleccion-personas">
						<div class="preseleccion-persona" v-for="(preseleccion, index) in preseleccionesFiltradas" :key="index">
							<div class="preseleccion-persona-eliminar" @click.prevent="eliminarPalcoIntegrante(preseleccion.palcoIntegranteId)" v-if="Number(preseleccion.palcoIntegranteId) !== Number(palcoIntegranteIdAEliminar)">
								<Trash2Icon></Trash2Icon>
							</div>
							<div class="preseleccion-persona-eliminar" @click.prevent="eliminarPalcoIntegrante(0)" v-if="Number(preseleccion.palcoIntegranteId) === Number(palcoIntegranteIdAEliminar)">
								<ArrowLeftIcon></ArrowLeftIcon>
							</div>
							<div class="preseleccion-persona-content" @click="elegirPreseleccion(preseleccion)" v-if="Number(preseleccion.palcoIntegranteId) !== Number(palcoIntegranteIdAEliminar)">
								<div class="preseleccion-persona-left">
									<div class="preseleccion-nombre">{{ preseleccion.personaNombre }} {{ preseleccion.personaApellido }}</div>
									<div class="preseleccion-documento">{{ preseleccion.personaDocumentoTipoAbr }} {{ preseleccion.personaDocumento }}</div>
								</div>
								<div class="preseleccion-persona-right"><arrow-right-icon></arrow-right-icon></div>
							</div>
							<div class="preseleccion-persona-eliminar-confirm" v-else>
								<span>¿Estás seguro que deseas eliminar a {{ preseleccion.personaNombre }} {{ preseleccion.personaApellido }}?</span>
								<button @click.prevent="eliminarPalcoIntegranteWS()">Si</button>
							</div>
						</div>
					</div>
				</div>
				<div class="preseleccion-palco-loader" v-else>
					<div class="loader">
						<img src="./../../assets/cndef-loader.gif" alt="Cargando...">
						<span v-if="isPalco">Cargando preselecciones de palco</span>
						<span v-else>Cargando preselecciones de paddocks</span>
					</div>
				</div>
			</div>
		</modal>
		<modal class="promptComunicaciones" name="promptComunicaciones" :clickToClose="false">
			<div class="comunicaciones-content">
				<div class="comunicaciones-header">
					<span class="atencion">
						¡Atención!
					</span>
					<div class="comunicaciones-cerrar" @click="$modal.hide('promptComunicaciones')" v-if="permitirCanje"><x-icon></x-icon></div>
				</div>
				<div class="comunicaciones-main">
					<div class="comunicacion" v-for="comunicacion in comunicaciones" :key="comunicacion.ComunicacionId">
						<div v-html="comunicacion.ComunicacionMensaje"></div>
						<div class="comunicacion-archivo" v-if="comunicacion.ComunicacionPalcoArchivoB64">
							<a class="comunicacion-descargar-archivo" :href="'data:application/octet-stream;base64,' + comunicacion.ComunicacionPalcoArchivoB64" :download="comunicacion.ComunicacionPalcoFileName + '.' + comunicacion.ComunicacionPalcoFileExtension">Descargar adjunto</a>
						</div>
					</div>
				</div>
			</div>
		</modal>

		<!-- <modal class="promptCancelarTicket" name="promptCancelarTicket" @closed="promptCancelarTicketClosed">
			<h2>¡Atención!</h2>
			<p>¿Estás seguro que deseas cancelar el ticket?</p>
			<div>
				<button @click="$modal.hide('promptCancelarTicket')" class="aux">No, volver</button>
				<button @click="cancelarTicket(cancelarTicketId)">Si, cancelar ticket</button>
			</div>
		</modal> -->
	</div>
</template>

<script>
	import axios from 'axios'
	import { MapIcon, DownloadIcon, XIcon, UsersIcon, ArrowRightIcon, LoaderIcon, Trash2Icon, ArrowLeftIcon } from 'vue-feather-icons'
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return {
				palco: {
					EspectaculoId: null,
					EscenarioId: null,
					TribunaId: null,
					SectorCod: null,
					SectorDescripcion: null,
					EspectaculoSectorEstado: null,
					EspectaculoSectorCapacidad: null,
					EspectaculoSectorSNDisponibilidad: null,
					PalcoId: null,
					PalcoDescripcion: null,
					PalcoNivel: null,
					PalcoHabilitado: null,
					PalcoMenoresCapacidad: null,
					PalcoMenoresDisponibilidad: null
				},
				espectaculo: {
					id: null,
					nombre: '',
					descripcion: '',
					descripcionPalcos: '',
					descripcionPaddock: '',
					tipoId: null,
					tipoNombre: '',
					tipoColor: '',
					requiereCompetencia: true,
					requiereInstituciones: true,
					institucionLocalNombre: '',
					institucionLocalEscudo: '',
					institucionVisitanteNombre: '',
					institucionVisitanteEscudo: '',
					fecha: '',
					fechaEscrita: '',
					fechaDiaSemanaEscrito: '',
					hora: '',
					escenarioNombre: '',
					escenarioLogo: '',
					escenarioSVG: '',
					escenarioMapaURL: '',
					competenciaNombre: '',
					competenciaInstanciaNombre: '',
					competenciaLogo: '',
					foto: null,
					requiereRepresentacionGrafica: true,
					mostrarCompetencia: false,
					mostrarFecha: false,
					mostrarEscenario: false
				},
				tickets: [],
				ticketsMenores: [],
				ticketsEmitidos: [],
				tipoDocumentoCI: null,
				tipoDocumentos: [],

				preselecciones: [],
				mostrarPreseleccion: false,
				ticketNumPreseleccion: null,
				ticketPreseleccionIsMenor: false,
				filtrosPreselecciones: {
					nombre: '',
					documento: ''
				},

				/* Descarga de archivos */
				espectaculoArchivos: [],
				base64: '',
				fileName: '',
				descargandoArchivo: false,

				/* Datos complementarios */
				datosComplementarios: [],

				/* Comunicaciones */
				comunicaciones: [],

				/* Cancelación de tickets */
				//cancelarTicketId: null,
				//isCancelandoTicket: false

				/* Eliminación de integrante */
				palcoIntegranteIdAEliminar: null,
			}
		},
		components: {
			MapIcon,
			DownloadIcon,
			XIcon,
			UsersIcon,
			ArrowRightIcon,
			ClipLoader,
			LoaderIcon,
			Trash2Icon,
			ArrowLeftIcon
		},
		async mounted(){
			this.$store.dispatch('cargando', true);
			await this.tiposDocumento();
			await this.validarPalco();
			await this.cargoPreselecciones();
			await this.cargoEspectaculoArchivos();
			this.$store.dispatch('cargando', false);
		},
		computed: {
			preseleccionesFiltradas: function(){
				return this.filtrarPreselecciones(this.preselecciones)
			},
			permitirCanje: function(){
				if(this.comunicaciones.length <= 0){
					return true
				} else {
					let permitir = true;
					this.comunicaciones.forEach((c) => {
						if(c.ComunicacionRestringe === true){
							permitir = false
						}
					})

					return permitir
				}
			},
			isPalco: function(){
				if(!this.palco){
					return true
				} else {
					if(Number(this.palco.TribunaId) === 10){
						return false
					} else {
						return true
					}
				}
			}
		},
		watch: {
			ticketsEmitidos(){
				this.ticketsEmitidos.forEach((t, index) => {
					if(t.TicketGeneradoEnS3 === false){
						this.timeoutCheckearTicket(t.TicketId, index);
					}
				});
			}
		},
		methods: {
			timeout(){
				return new Promise(resolve => setTimeout(resolve, 5000));
			},
			async timeoutCheckearTicket(ticketId, index){
				do {
					await this.timeout();
					await this.checkearTicketGenerado(ticketId);
				} while (this.ticketsEmitidos[index].TicketGeneradoEnS3 === false)
			},
			async checkearTicketGenerado(ticketId){
				try {
					let response = await axios.post('/WSTicketGeneradoEnS3', { TicketId: Number(ticketId) });
					
					if(response.data.ErrorCod === 0){
						if(response.data.isGeneradoEnS3 === true){
							let indexEmitidos = this.ticketsEmitidos.map(ticket => ticket.TicketId).indexOf(ticketId)
							this.ticketsEmitidos[indexEmitidos].TicketGeneradoEnS3 = true;
						}
					} else {
						console.log('Ocurrió un error al checkear generación del PDF')
					}
				} catch (error) {
					console.log('Ocurrió un error al checkear generacion del PDF')
				}
			},
			async descargarArchivo(archivoId){
				try {
					this.descargandoArchivo = true

					let response = await axios.post('/WSEspectaculoArchivoDescargar', { EspectaculoId : Number(this.$route.params.espectaculoId), EspectaculoArchivoId: Number(archivoId) });

					if(response.data.ErrorCod === 0){
						this.base64 = 'data:application/octet-stream;base64,' + response.data.SDTEspectaculoArchivo.EspectaculoArchivoArchivoB64.trim();
						this.fileName = response.data.SDTEspectaculoArchivo.EspectaculoArchivoNombre.trim() + response.data.SDTEspectaculoArchivo.ArchivoTipoExtension.trim();
						// setTimeout(function(){ document.querySelector('.descargar-archivo').click();}, 500);
						await new Promise(resolve => setTimeout(resolve, 500));
						document.querySelector('.descargar-archivo').click();
						this.descargandoArchivo = false;
					} else {
						this.descargandoArchivo = false
					}
				} catch (error) {
					this.descargandoArchivo = false;
					this.$store.dispatch('mostrarError', 'Ocurrió un error al descargar el archivo')
				}
			},
			filtrarPreselecciones: function(preselecciones){
				if(!this.filtrosPreselecciones.nombre && !this.filtrosPreselecciones.documento){
					return preselecciones;
				} else {
					if(this.filtrosPreselecciones.nombre && !this.filtrosPreselecciones.documento){
						return preselecciones.filter(p => ((p.personaNombre.toUpperCase() + ' ' + p.personaApellido.toUpperCase()).indexOf(this.filtrosPreselecciones.nombre.toUpperCase())) >= 0 ? p : '');
					} else {
						if(!this.filtrosPreselecciones.nombre && this.filtrosPreselecciones.documento){
							return preselecciones.filter(p => (p.personaDocumento.toUpperCase().indexOf(this.filtrosPreselecciones.documento.toUpperCase())) >= 0 ? p : '');
						} else {
							return preselecciones.filter(p => ((p.personaNombre.toUpperCase() + ' ' + p.personaApellido.toUpperCase()).indexOf(this.filtrosPreselecciones.nombre.toUpperCase())) >= 0 && (p.personaDocumento.toUpperCase().indexOf(this.filtrosPreselecciones.documento.toUpperCase())) >= 0 ? p : '');
						}
					}
				}
			},
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async tiposDocumento(){
				// Obtengo tipos de documento
				try{
					let response = await axios.post('/WSDocumentoTipoCortesiaPalco', {});
					for(var o=0; o<response.data.SDTDocumentoTipo.length; o++){
						this.tipoDocumentos.push({ valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre });

						if(Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(response.data.SDTDocumentoTipo[o].DocumentoTipoId), descripcion: response.data.SDTDocumentoTipo[o].DocumentoTipoNombre }
						}
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async validarPalco(){
				// Valido cortesía
				try{
					let response = await axios.post('/WSPalquistaValidar', { 
						EspectaculoId: Number(this.$route.params.espectaculoId), TribunaId: Number(this.$route.params.tribunaId), SectorCod: this.$route.params.sectorCod, Token: this.$route.params.palcoToken }, {});

					if(response.data.ErrorCod === 0){
						this.palco = response.data.SDTEspectaculoPalco;

						this.ticketsEmitidos = response.data.SDTTicketPalco.Ticket;
						this.tickets = [];
						this.ticketsMenores = [];
						this.datosComplementarios = [];

						let indice = 0
						if(Number(this.palco.EspectaculoSectorSNDisponibilidad) > 0){
							for(let i = 0; i<Number(this.palco.EspectaculoSectorSNDisponibilidad); i++){
								let sector = this.palco.SectorDescripcion.replace('Palco ', '')
								let tribuna = this.palco.TribunaNombre.replace('Palcos ', '')

								indice = indice + 1
								
								let ticket = {
									ticketNum: indice,
									ticketNombre: '',
									ticketApellido: '',
									ticketDocumentoTipo: this.tipoDocumentoCI,
									ticketDocumento: '',
									ticketTelefono: '',
									ticketTribuna: tribuna,
									ticketSector: sector,
									ticketPalcoNivel: this.palco.PalcoNivel,
									datosComplementarios: []
								}

								this.tickets.push(ticket);
							}
						}

						if(Number(this.palco.PalcoMenoresDisponibilidad) > 0){
							for(let i = 0; i<Number(this.palco.PalcoMenoresDisponibilidad); i++){
								let sector = this.palco.SectorDescripcion.replace('Palco ', '')
								let tribuna = this.palco.TribunaNombre.replace('Palcos ', '')

								indice = indice + 1
								
								let ticket = {
									ticketNum: indice,
									ticketNombre: '',
									ticketApellido: '',
									ticketDocumentoTipo: this.tipoDocumentoCI,
									ticketDocumento: '',
									ticketTelefono: '',
									ticketTribuna: tribuna,
									ticketSector: sector,
									ticketPalcoNivel: this.palco.PalcoNivel,
									datosComplementarios: []
								}

								this.ticketsMenores.push(ticket);
							}
						}

						let data = response.data.SDTEspectaculo;
						this.espectaculo.id = Number(data.EspectaculoId);
						this.espectaculo.nombre = data.EspectaculoNombre;
						this.espectaculo.descripcion = data.EspectaculoDescripcion;
						this.espectaculo.descripcionPalcos = data.EspectaculoDescripcionPalcos;
						this.espectaculo.descripcionPaddock = data.EspectaculoDescripcionPaddock;
						this.espectaculo.tipoId = Number(data.EspectaculoTipoId);
						this.espectaculo.tipoNombre = data.EspectaculoTipoNombre;
						this.espectaculo.tipoColor = data.EspectaculoTipoColor;
						this.espectaculo.requiereCompetencia = data.EspectaculoTipoRequiereCompetencia;
						this.espectaculo.requiereInstituciones = data.EspectaculoTipoRequiereInstitucion;
						this.espectaculo.institucionLocalNombre = data.InstitucionLocalNombre;
						this.espectaculo.institucionLocalEscudo = data.InstitucionLocalEscudoURL;
						this.espectaculo.institucionVisitanteNombre = data.InstitucionVisitanteNombre;
						this.espectaculo.institucionVisitanteEscudo = data.InstitucionVisitanteEscudoURL;
						this.espectaculo.fechaEscrita = data.EspectaculoFechaEscrita;
						this.espectaculo.fechaDiaSemanaEscrito = data.EspectaculoFechaDiaSemanaEscrito;
						this.espectaculo.hora = data.EspectaculoHora;
						this.espectaculo.escenarioNombre = data.EscenarioNombre;
						this.espectaculo.escenarioLogo = data.EscenarioLogoURL;
						this.espectaculo.escenarioMapaURL = data.EscenarioMapaURL;
						this.espectaculo.competenciaNombre = data.CompetenciaNombre;
						this.espectaculo.competenciaInstanciaNombre = data.CompetenciaInstanciaNombre;
						this.espectaculo.competenciaLogo = data.CompetenciaImagenURL;
						this.espectaculo.requiereRepresentacionGrafica = data.EspectaculoRepresentacionGrafica;
						if (data.EspectaculoFotoURL.length > 0) {
							this.espectaculo.foto = data.EspectaculoFotoURL;
						} else {
							this.espectaculo.foto = process.env.VUE_IMG_BUCKET + 'parque-aereo.jpg';
						}
						this.espectaculo.mostrarCompetencia = data.EspectaculoFrontMostrarCompetencia;
						this.espectaculo.mostrarFecha = data.EspectaculoFrontMostrarFecha;
						this.espectaculo.mostrarEscenario = data.EspectaculoFrontMostrarEscenario;

						this.comunicaciones = response.data.SDTEspectaculoComunicaciones

						if(this.comunicaciones.length > 0){
							this.$modal.show('promptComunicaciones');
						}

						await this.cargoDatosComplementarios();
					} else {
						this.$router.push({ name: 'error' });
					}
				} catch (error){
					this.$router.push({ name: 'error' });
				}
			},
			async canjearPalcos(){
				let auxTickets = [
					...this.tickets.map(ticket => ({
						...ticket,
						IsMenor: false
					})),
					...this.ticketsMenores.map(ticket => ({
						...ticket,
						IsMenor: true
					}))
				];

				console.log(auxTickets);

				let TicketComplemento;
				let SDTComplementosValores = [];
				let SDTComplementosValoresJSON = '';

				let todosVacios = true
				for(let v=0; v<auxTickets.length; v++){
					if(auxTickets[v].ticketApellido || auxTickets[v].ticketNombre || auxTickets[v].ticketDocumento){
						todosVacios = false
						break;
					}
				}

				let hayRepetidos = false

				if(todosVacios === true){
					this.$store.dispatch('mostrarError', 'Debes ingresar al menos una invitación')
				} else {
					let auxSDTTicketPalco = {
						EspectaculoId: Number(this.$route.params.espectaculoId),
						TribunaId: Number(this.$route.params.tribunaId),
						SectorCod: this.$route.params.sectorCod,
						Ticket: []
					}

					let hayError = false;
					for(let m=0; m<auxTickets.length; m++){
						if(auxTickets[m].ticketApellido || auxTickets[m].ticketNombre || auxTickets[m].ticketDocumento){
							if(auxTickets[m].ticketApellido && auxTickets[m].ticketNombre && auxTickets[m].ticketDocumento){
								for(let k=0; k<auxTickets.length; k++){
									if(k !== m){
										if(auxTickets[m].ticketDocumento && auxTickets[m].ticketDocumento === auxTickets[k].ticketDocumento){
											hayRepetidos = true;
											break;
										}
									}
								}

								if(hayRepetidos === true){
									hayError = true
									this.$store.dispatch('mostrarError', 'Hay documentos repetidos')
									break;
								} else {
									// if(this.tickets[m].ticketTelefono.length < 8 || this.tickets[m].ticketTelefono.length > 20){
									// 	hayError = true
									// 	this.$store.dispatch('mostrarError', 'Ticket #' + this.tickets[m].ticketNum + ' - Teléfono incorrecto')
									// 	break;
									// } else {
										// Validación datos complementarios
										for(let k=0; k<this.datosComplementarios.length; k++){
											let isDatoObligatorio = this.datosComplementarios[k].EspectaculoComplementoObligatorio;

											if(isDatoObligatorio){
												if(!auxTickets[m].datosComplementarios[k].Valor && this.datosComplementarios[k].ComplementoTipo === 'O'){
													hayError = true
													this.$store.dispatch('mostrarError', 'Ticket #' + auxTickets[m].ticketNum + ': debes seleccionar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
													break;
												}

												if(this.datosComplementarios[k].ComplementoTipo !== 'O'){
													if(!auxTickets[m].datosComplementarios[k].Valor){
														hayError = true
														this.$store.dispatch('mostrarError', 'Ticket #' + auxTickets[m].ticketNum + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
														break;
													} else {
														if(auxTickets[m].datosComplementarios[k].Valor.trim() === ''){
															hayError = true
															this.$store.dispatch('mostrarError', 'Ticket #' + auxTickets[m].ticketNum + ': debes ingresar ' + this.datosComplementarios[k].ComplementoNombre.toLowerCase())
															break;
														}
													}
												}
											}
										}

										if(hayError === true){
											break;
										}

										let itemTicketPalco = {
											Num: Number(auxTickets[m].ticketNum),
											TicketFechaEmision: null,
											TicketMonto: 0,
											TicketTipo: '',
											TicketEstado: '',
											PersonaNombre: auxTickets[m].ticketNombre.trim(),
											PersonaApellido: auxTickets[m].ticketApellido.trim(),
											PersonaDocumentoTipoId: Number(auxTickets[m].ticketDocumentoTipo.valor),
											PersonaDocumento: auxTickets[m].ticketDocumento,
											// PersonaTelefono: auxTickets[m].ticketTelefono,
											PersonaTelefono: '',
											PersonaSocioCategoriaId: 0,
											PersonaSocioNro: '',
											TransaccionId: 0,
											IsMenor: auxTickets[m].IsMenor
										}

										auxSDTTicketPalco.Ticket.push(itemTicketPalco);

										for(let s=0; s<auxTickets[m].datosComplementarios.length; s++){
											let value = null;

											if(this.datosComplementarios[s].ComplementoTipo === 'O'){
												if(auxTickets[m].datosComplementarios[s].Valor){
													value = auxTickets[m].datosComplementarios[s].Valor.valor;
												}
											} else {
												if(auxTickets[m].datosComplementarios[s].Valor && auxTickets[m].datosComplementarios[s].Valor.trim() !== ''){
													value = auxTickets[m].datosComplementarios[s].Valor;
												}
											}

											if(value){
												TicketComplemento = {
													Index: Number(auxTickets[m].ticketNum),
													ComplementoId: auxTickets[m].datosComplementarios[s].ComplementoId,
													ComplementoRegistroValor: value
												}

												SDTComplementosValores.push(TicketComplemento);
											}
										}
									// }
								}
							} else {
								hayError = true
								this.$store.dispatch('mostrarError', 'Debes ingresar todos los datos para el ticket #' + auxTickets[m].ticketNum)
							}
						}
					}

					SDTComplementosValoresJSON = JSON.stringify(SDTComplementosValores);

					if(hayError === false){
						this.$store.dispatch('cargando', true);

						// Canjeo invitaciones a palcos
						try{
							let response = await axios.post('/WSPalquistaTicket', { Token: this.$route.params.palcoToken, SDTTicketPalco: auxSDTTicketPalco, SDTComplementosValoresJSON: SDTComplementosValoresJSON })

							if(response.data.ErrorCod === 0){
								this.$store.dispatch('mostrarSuccess', 'Invitaciones a palquistas emitidas correctamente')
								await this.validarPalco();
								this.$store.dispatch('cargando', false);
							} else {
								if(response.data.ErrorCod === 10 || response.data.ErrorCod === 11 || response.data.ErrorCod === 20 || response.data.ErrorCod === 21 || response.data.ErrorCod === 30 || response.data.ErrorCod === 31 || response.data.ErrorCod === 32 || response.data.ErrorCod === 33 || response.data.ErrorCod === 1 || response.data.ErrorCod === 40 || response.data.ErrorCod === 34){
									this.$store.dispatch('mostrarError', 'Ocurrió un error')
									this.$router.push({ name: 'error' });
								} else {
									this.$store.dispatch('mostrarError', response.data.ErrorDsc)
									this.$store.dispatch('cargando', false);
								}
							}
						} catch(error){
							this.$store.dispatch('mostrarError', 'Ocurrió un error')
							this.$store.dispatch('cargando', false);
						}
					}
				}
			},
			async cargoEspectaculoArchivos(){
				try {
					let response = await axios.post('/WSEspectaculoArchivosPalcos', { EspectaculoId : Number(this.$route.params.espectaculoId) });

					if(response.data.ErrorCod === 0){
						this.espectaculoArchivos = response.data.SDTEspectaculoArchivos
					} else {
						// Redirigir a home
						this.$router.push({ name: 'home' });
					}
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async cargoDatosComplementarios(){
				try {
					let response = await axios.post('/WSEspectaculoDatosComplPalco', { EspectaculoId : Number(this.$route.params.espectaculoId) });
					
					if(response.data.ErrorCod === 0){
						response.data.SDTDatosComplementarios.map((d)=>{
							let opciones = [];
							let opcion = {}

							if(d.Opciones.length){
								for(let i = 0; i<d.Opciones.length; i++){
									opcion = {
										valor: d.Opciones[i].ComplementoOpcionId,
										descripcion: d.Opciones[i].ComplementoOpcionValor
									}

									opciones.push(opcion)
								}
							}
							
							let datoComplementario = {
								ComplementoId: d.ComplementoId,
								ComplementoNombre: d.ComplementoNombre,
								ComplementoTipo: d.ComplementoTipo,
								Opciones: opciones,
								EspectaculoComplementoObligatorio: d.EspectaculoComplementoObligatorio
							}

							this.datosComplementarios.push(datoComplementario);

							for(let j = 0; j<this.tickets.length; j++){
								this.tickets[j].datosComplementarios.push({ ComplementoId: d.ComplementoId, Valor: null });
							}

							for(let k = 0; k<this.ticketsMenores.length; k++){
								this.ticketsMenores[k].datosComplementarios.push({ ComplementoId: d.ComplementoId, Valor: null });
							}
						});
					}
				} catch (error) {
					console.log('Error al cargar datos complementarios')
				}
			},
			async cargoPreselecciones(){
				let response = await axios.post('/WSPalcoIntegrante', { EspectaculoId: Number(this.$route.params.espectaculoId), TribunaId: Number(this.$route.params.tribunaId), SectorCod: this.$route.params.sectorCod, Token: this.$route.params.palcoToken });
				let palcoIntegrantes = response.data.SDTPalcoIntegrantes
				
				if(palcoIntegrantes.length > 0){
					for(let i = 0; i < palcoIntegrantes.length; i++){
						let preseleccionItem = {
							// descripcion: "Gonzalo Bergessio (84212844) Cel: 542515515",
							descripcion: '',
							personaApellido: palcoIntegrantes[i].PalcoIntegrantePersonaApellido,
							personaDocumento: palcoIntegrantes[i].PalcoIntegrantePersonaDocumento,
							personaDocumentoTipo: palcoIntegrantes[i].PalcoIntegranteDocumentoTipoId,
							personaDocumentoTipoAbr: palcoIntegrantes[i].PalcoIntegranteDocumentoTipoAbr,
							personaId: palcoIntegrantes[i].PalcoIntegrantePersonaId,
							personaNombre: palcoIntegrantes[i].PalcoIntegrantePersonaNombre,
							personaPreText: '',
							personaSocioNro: null,
							personaTelefono: palcoIntegrantes[i].PalcoIntegrantePersonaTelefono,
							palcoIntegranteId: palcoIntegrantes[i].PalcoIntegranteId
						}

						this.preselecciones.push(preseleccionItem)
					}
				}
			},
			showPreselecciones(ticketNum, isMenor){
				this.mostrarPreseleccion = true;
				this.ticketNumPreseleccion = ticketNum
				this.ticketPreseleccionIsMenor = isMenor
				this.$modal.show('promptPreseleccionPalco');
			},
			cerrarPreseleccion(){
				this.$modal.hide('promptPreseleccionPalco');
				this.ticketNumPreseleccion = null
				this.ticketPreseleccionIsMenor = false;
				this.mostrarPreseleccion = false;
			},
			elegirPreseleccion(preseleccion){
				let descripcionDocumento = '';
				for(let n=0; n<this.tipoDocumentos.length; n++){
					if(Number(preseleccion.personaDocumentoTipo) === Number(this.tipoDocumentos[n].valor)){
						descripcionDocumento = this.tipoDocumentos[n].descripcion
						break;
					}
				}

				let tnum = this.ticketNumPreseleccion;
				let isMenor = this.ticketPreseleccionIsMenor;

				let item = isMenor ? this.ticketsMenores.find(ticket => ticket.ticketNum === tnum) : this.tickets.find(ticket => ticket.ticketNum === tnum);
				if (item) {
					item.ticketNombre = preseleccion.personaNombre
					item.ticketApellido = preseleccion.personaApellido
					item.ticketDocumentoTipo.valor = Number(preseleccion.personaDocumentoTipo)
					item.ticketDocumentoTipo.descripcion = descripcionDocumento
					item.ticketDocumento = preseleccion.personaDocumento
					item.ticketTelefono = preseleccion.personaTelefono
				}


				// this.tickets[tnum - 1].ticketNombre = preseleccion.personaNombre
				// this.tickets[tnum - 1].ticketApellido = preseleccion.personaApellido
				// this.tickets[tnum - 1].ticketDocumentoTipo.valor = Number(preseleccion.personaDocumentoTipo)
				// this.tickets[tnum - 1].ticketDocumentoTipo.descripcion = descripcionDocumento
				// this.tickets[tnum - 1].ticketDocumento = preseleccion.personaDocumento
				// this.tickets[tnum - 1].ticketTelefono = preseleccion.personaTelefono

				this.cerrarPreseleccion();
			},
			async eliminarPalcoIntegrante(palcoIntegranteId){
				if(Number(palcoIntegranteId) > 0){
					this.palcoIntegranteIdAEliminar = Number(palcoIntegranteId)
				} else {
					this.palcoIntegranteIdAEliminar = null
				}
			},
			async eliminarPalcoIntegranteWS(){
				try {
					this.mostrarPreseleccion = false;

					if(Number(this.palcoIntegranteIdAEliminar) > 0){
						let response = await axios.post('/WSPalcoIntegranteEliminar', {
							EspectaculoId: Number(this.$route.params.espectaculoId), 
							TribunaId: Number(this.$route.params.tribunaId), 
							SectorCod: this.$route.params.sectorCod, 
							Token: this.$route.params.palcoToken,
							PalcoIntegranteId: Number(this.palcoIntegranteIdAEliminar)
						}, {});

						if(response.data.ErrorCod === 0){
							let palcoIntegrantes = response.data.SDTPalcoIntegrantes
				
							if(palcoIntegrantes.length > 0){
								this.preselecciones = [];

								for(let i = 0; i < palcoIntegrantes.length; i++){
									let preseleccionItem = {
										descripcion: '',
										personaApellido: palcoIntegrantes[i].PalcoIntegrantePersonaApellido,
										personaDocumento: palcoIntegrantes[i].PalcoIntegrantePersonaDocumento,
										personaDocumentoTipo: palcoIntegrantes[i].PalcoIntegranteDocumentoTipoId,
										personaDocumentoTipoAbr: palcoIntegrantes[i].PalcoIntegranteDocumentoTipoAbr,
										personaId: palcoIntegrantes[i].PalcoIntegrantePersonaId,
										personaNombre: palcoIntegrantes[i].PalcoIntegrantePersonaNombre,
										personaPreText: '',
										personaSocioNro: null,
										personaTelefono: palcoIntegrantes[i].PalcoIntegrantePersonaTelefono,
										palcoIntegranteId: palcoIntegrantes[i].PalcoIntegranteId
									}

									this.preselecciones.push(preseleccionItem)
								}
							}
						} else {
							this.$store.dispatch('mostrarError', 'Ocurrió un error al eliminar persona')
						}
					}

					this.mostrarPreseleccion = true;
				} catch (error) {
					console.log(error);
					this.$store.dispatch('mostrarError', 'Ocurrió un error al eliminar persona')
				}
			}
			// async showModalCancelarTicket(ticketId){
			// 	try {
			// 		this.cancelarTicketId = Number(ticketId)
			// 		this.$modal.show('promptCancelarTicket')
			// 	} catch (error) {
			// 		console.log('Ocurrió un error al cancelar el ticket');
			// 	}
			// },
			// async cancelarTicket(ticketId){
			// 	try {
			// 		this.isCancelandoTicket = true;

			// 		let response = await axios.post('/WSPalquistaTicketCancelar', { 
			// 			EspectaculoId: Number(this.$route.params.espectaculoId), 
			// 			TribunaId: Number(this.$route.params.tribunaId), 
			// 			SectorCod: this.$route.params.sectorCod, 
			// 			Token: this.$route.params.palcoToken,
			// 			TicketId: Number(ticketId)
			// 		}, {});

			// 		if(response.data.ErrorCod === 0){
			// 			this.$modal.hide('promptCancelarTicket')
			// 			this.$store.dispatch('cargando', true);
			// 			await this.validarPalco();
			// 			this.$store.dispatch('mostrarSuccess', 'Ticket cancelado correctamente')
			// 			this.$store.dispatch('cargando', false);
			// 		} else {
			// 			this.$store.dispatch('mostrarError', response.data.ErrorDsc)
			// 			console.log('Ocurrió un error al cancelar el ticket.');
			// 		}
			// 	} catch (error) {
			// 		this.$store.dispatch('mostrarError', 'Ocurrió un error al cancelar el ticket, intenta nuevamente.')
			// 		console.log('Ocurrió un error al cancelar el ticket.');
			// 	} finally {
			// 		this.isCancelandoTicket = false;
			// 	}
			// },
			// async promptCancelarTicketClosed(){
			// 	this.cancelarTicketId = null
			// }
		}
	}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss">
	// Multiselects
	.multiselect {
		min-height: 44px;
		width: 100%;
		cursor: pointer;
		transition: all 0.2s;

		&:hover .multiselect__tags {
			transition: all 0.2s;
			border-color: var(--color-blue);
		}
	}

	.multiselect__input,
	.multiselect__single {
		margin: 0;
		font-size: 16px;
		line-height: 25px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-left: 0;
	}

	.multiselect__tags {
		border-radius: 0px;
		font-size: 16px;
		line-height: 25px;
		border: none;
		border-bottom: 1px solid var(--color-grey-light);
		display: block;
		width: 100%;
		height: 100%;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
		padding-top: 8px;
		padding-bottom: 10px;
		padding-left: 0px;
		padding-right: 40px;
		outline: none;
		background-color: var(--color-white);
	}

	.multiselect__option--highlight {
		background-color: var(--color-grey-lighter);
		color: var(--color-black);
	}

	.multiselect__option--selected.multiselect__option--highlight {
		background-color: var(--color-red);
		// border-left: 2px solid var(--color-blue-dark);
		color: var(--color-white);
	}

	.multiselect__option {
		font-size: 13px;
		line-height: 13px;
		font-weight: var(--font-weight-bold);
		-webkit-letter-spacing: 0;
		-moz-letter-spacing: 0;
		-ms-letter-spacing: 0;
		letter-spacing: 0;
		color: var(--color-dark);
		font-family: var(--font-family-poppins);
		text-transform: uppercase;
	}

	.multiselect__option--selected {
		background-color: var(--color-blue);
		color: var(--color-white);
		font-size: 13px;
		line-height: 13px;
	}

	.multiselect__option--highlight:after {
		background: transparent;
		color: #999;
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__option--selected.multiselect__option--highlight:after,
	.multiselect__option--selected:after {
		background: transparent;
		color: var(--color-white);
		font-size: 12px;
		font-weight: 300;
	}

	.multiselect__tag {
		margin-bottom: 3px !important;
		margin-right: 8px !important;
		background: var(--color-blue) !important;
	}

	.multiselect__tag-icon:after {
		color: var(--color-white) !important;
	}

	.multiselect__tag-icon:focus,
	.multiselect__tag-icon:hover {
		background: none !important;
	}

	.multiselect__placeholder {
		padding-top: 0px;
		margin-bottom: 0px;
	}

	@media screen and(max-width: 590px){
		.multiselect__input, .multiselect__single{
			font-size: 14px !important;
		}

		.multiselect__tags{
			padding-top: 10px;
			padding-bottom: 6px;
			padding-right: 30px;
		}
	}
</style>

<style lang="scss" scoped>
	.palco-page{
		min-height: var(--height-page);
		width: 100%;
		margin: 0;
		padding: 0;
		position: relative;
		@include flex(column, flex-start, center);

		.palco-header{
			padding-top: 76px;
			width: 100%;
			position: relative;
			height: 310px;
			background: url('../../assets/sports-player-background.jpg');
			background-position: center center;
			background-size: cover;
			background-repeat: no-repeat;
			@include flex(column, flex-start, center);

			.container{
				height: 100%;
				margin: 0;
				width: 100%;
				@include flex(column, flex-end, center);

				max-width: 1166px;
				padding: 0px 16px;
				z-index: 1;
				padding-bottom: 10px;
				@include flex(column, flex-end, flex-start);
			}

			.header-row{
				width: 100%;
				margin: 5px 0;
				@include flex(row, flex-start, center);

				.header-tipo{
					margin: 0;
					padding: 0;
					
					span{
						border-radius: 4px;
						background-color: var(--color-red);
						color: #fff;
						font-size: 11px;
						line-height: 1em;
						padding: 3px 7px;
						text-transform: uppercase;
						font-family: var(--font-family-poppins);
						letter-spacing: 0.5px;
					}
				}

				.header-equipos{
					margin: 5px 0 15px 0;
					padding: 0;
					position: relative;
					@include flex(column, center, flex-start);

					.header-equipo{
						@include flex(flex, flex-start, center);

						span{
							// font-family: 'Staatliches', cursive;
							line-height: 1.1em;
							color: var(--color-white);
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							text-transform: uppercase;
						}

						&.header-equipo-local{

							span{
								font-size: 32px;

								&.vs{
									font-family: var(--font-family-poppins);
									line-height: 1em;
									color: var(--color-blue-light);
									font-size: 24px;
									margin-left: 10px;
									margin-top: 6px;
									font-weight: var(--font-weight-bold);
								}
							}

							.header-escudo{
								height: 39px;
								width: auto;
								margin-right: 10px;
							}
						}

						&.header-equipo-visitante{
							margin-top: 5px;
							
							span{
								font-size: 30px;
							}

							.header-escudo{
								height: 34px;
								width: auto;
								margin-right: 10px;
								margin-left: 3px;
							}
						}
					}
				}
			}
		}

		.palco-main{
			width: 100%;
			position: relative;
			margin: 64px 0;
			@include flex(row, space-between, flex-start);
			
			.container{
				width: 100%;
				max-width: 1166px;
				padding: 0px 16px;
				@include flex(row, space-between, flex-start);

				.palco-right{
					top: 102px;
					position: sticky;
					margin-top: 41px;
					width: calc(33.33% - 16px);

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
						margin-bottom: 18px;
					}

					.palco-right-content{
						border-radius: 8px;
						border: 1px solid #d3d3dc;
						@include flex(column, flex-start, flex-start);

						.competencia{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(row, space-between, center);

							.competencia-info{
								@include flex(column, center, flex-start);

								span.competencia-nombre{
									margin: 0;
									font-size: 13px;
									line-height: 20px;
									margin-bottom: 0px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									color: var(--color-dark);
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
								}

								span.competencia-instancia{
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 15px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}

							img{
								height: 32px;
								width: auto;
								margin-left: 15px;
							}
						}

						.fecha{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.fecha-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.fecha-content{
								width: 100%;
								@include flex(row, space-between, center);

								.fecha-texto{
									@include flex(column, center, flex-start);

									p{
										color: var(--color-dark);
										font-family: var(--font-family-fira);
										font-weight: var(--font-weight-regular);
										font-size: 15px;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 20px;
										margin: 0;
									}
								}

								.fecha-hora{
									height: 100%;
									margin-left: 14px;
									border-left: 1px solid #d3d3dc;
									padding: 10px 0 10px 14px;
									color: var(--color-dark);
									font-family: var(--font-family-fira);
									font-weight: var(--font-weight-regular);
									font-size: 21px;
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									line-height: 20px;
								}
							}
						}

						.lugar{
							border-radius: 0px;
							border: none;
							padding: 20px;
							border-bottom: 1px solid #d3d3dc;
							width: 100%;
							@include flex(column, flex-start, flex-start);

							.lugar-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.lugar-content{
								@include flex(row, space-between, center);
								width: 100%;

								.lugar-content-left{
									@include flex(row, flex-start, center);

									.lugar-info{
										padding-right: 12px;
										// border-right: 1px solid #d3d3dc;
										@include flex(column, center, flex-start);

										span.lugar-escenario{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 15px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 20px;
										}

										span.lugar-direccion{
											color: var(--color-dark);
											font-family: var(--font-family-fira);
											font-weight: var(--font-weight-regular);
											font-size: 13px;
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 18px;
										}
									}

									img{
										width: 28px;
										height: auto;
										margin-left: 12px;
									}
								}

								.ver-mapa{
									@include flex(column, center, center);
									margin-left: 12px;

									a{
										background-color: transparent;
										border: 1px solid var(--color-blue-darker);
										padding: 6px;
										text-decoration: none;
										@include flex(row, center, center);
										transition: all .2s;
										border-radius: 99px;

										svg{
											width: 15px;
											height: auto;
											transition: all .2s;
											color: var(--color-blue-darker);
										}

										&:hover{
											background-color: var(--color-blue-darker);

											svg{
												color: var(--color-white);
											}
										}
									}
								}
							}
						}

						.descripcion{
							border-radius: 0px;
							border: none;
							padding: 20px;
							width: 100%;
							@include flex(column, flex-start, flex-start);
							
							.descripcion-title{
								margin: 0;
								font-size: 13px;
								line-height: 20px;
								margin-bottom: 2px;
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								color: var(--color-dark);
								font-family: var(--font-family-poppins);
								text-transform: uppercase;
							}

							.descripcion-content{
								color: var(--color-dark);
								font-family: var(--font-family-fira);
								font-weight: var(--font-weight-regular);
								font-size: 15px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								line-height: 20px;
							}
						}
					}
				}

				.palco-left{
					width: calc(66.66% - 16px);
					background-color: var(--color-white);
					padding: 0px;

					h1{
						margin: 0;
						margin-top: -5px;
						color: var(--color-red);
						font-weight: initial;
						font-size: 48px;
						line-height: 46px;
						font-family: var(--font-family-kapra-bold);
						text-transform: uppercase;
					}

					p{
						margin: 0;
						font-size: 18px;
						line-height: 26px;
						font-family: var(--font-family-fira);
						font-weight: bold;
						color: var(--color-dark);
					}

					.info-palquistas{
						width: 100%;
						@include flex(column, center, flex-start);
						margin: 10px 0px;
						border: 1px dashed var(--color-blue-dark);
						padding: 15px;
						
						.info-palquistas-title{
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							color: var(--color-blue-dark);
							text-transform: uppercase;
							font-size: 14px;
						}

						.info-palquistas-text{
							font-family: var(--font-family-fira);
							color: var(--color-blue-dark);
							font-size: 13px;
							margin-top: 3px;
						}
					}

					.tickets{
						width: 100%;
						margin-top: 20px;
						display: grid;
						grid-template-columns: repeat(1, 1fr);
						grid-row-gap: 25px;

						.ticket{
							border-radius: 0px;
							box-shadow: 0 2px 28px 0 rgba(0, 0, 0, 0.1);
							width: 100%;
							padding: 20px;
							padding-left: 70px;
							position: relative;
							background-color: var(--color-white);
							@include flex(column, flex-start, flex-start);
							transition: all .2s;

							&:hover{
								&:after{
									opacity: 0.9;
								}

								&:before{
									opacity: 0.9;
								}
							}

							&:after{
								content: 'Invitación';
								position: absolute;
								top: 0px;
								left: 0px;
								width: 50px;
								height: calc(100% - 50px);
								@include flex(row, center, center);
								color: var(--color-white);

								writing-mode:vertical-lr;

								font-family: var(--font-family-poppins);
								text-transform: uppercase;
								-webkit-letter-spacing: 2px;
								-moz-letter-spacing: 2px;
								-ms-letter-spacing: 2px;
								letter-spacing: 2px;
								font-size: 13px;
								background-color: var(--color-blue);
							}

							&:before{
								content: '';
								position: absolute;
								bottom: 0px;
								left: 0px;
								width: 50px;
								height: 50px;
								color: var(--color-white);
								font-weight: var(--font-weight-bold);
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								font-family: var(--font-family-poppins);
								@include flex(row, center, center);
								background-color: var(--color-red);
							}

							&#tn1:before{
								content: '#1';
							}

							&#tn2:before{
								content: '#2';
							}

							&#tn3:before{
								content: '#3';
							}

							&#tn4:before{
								content: '#4';
							}

							&#tn5:before{
								content: '#5';
							}

							&#tn6:before{
								content: '#6';
							}

							&#tn7:before{
								content: '#7';
							}

							&#tn8:before{
								content: '#8';
							}

							&#tn9:before{
								content: '#9';
							}

							&#tn10:before{
								content: '#10';
							}

							&#tn11:before{
								content: '#11';
							}

							&#tn12:before{
								content: '#12';
							}

							&#tn13:before{
								content: '#13';
							}

							&#tn14:before{
								content: '#14';
							}

							&#tn15:before{
								content: '#15';
							}

							&#tn16:before{
								content: '#16';
							}

							&#tn17:before{
								content: '#17';
							}

							&#tn18:before{
								content: '#18';
							}

							&#tn19:before{
								content: '#19';
							}

							&#tn20:before{
								content: '#20';
							}

							&#tn21:before{
								content: '#21';
							}

							&#tn22:before{
								content: '#22';
							}

							&#tn23:before{
								content: '#23';
							}

							&#tn24:before{
								content: '#24';
							}

							&#tn25:before{
								content: '#25';
							}

							&#tn26:before{
								content: '#26';
							}

							&#tn27:before{
								content: '#27';
							}

							&#tn28:before{
								content: '#28';
							}

							&#tn29:before{
								content: '#29';
							}

							&#tn30:before{
								content: '#30';
							}

							.palco-row{
								width: 100%;
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
									padding: 0px 8px 8px 8px;
									margin: 0;
									@include flex(column, center, flex-start);
									position: relative;

									&:first-child{
										padding-left: 0px;
									}

									&:last-child{
										padding-right: 0px;
									}

									label{
										font-size: 16px;
										font-weight: var(--font-weight-regular);
										color: var(--color-grey);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										line-height: 19px;
										font-family: var(--font-family-fira);
									}

									input{
										font-size: 16px;
										line-height: 25px;
										padding-top: 8px;
										border-bottom: 1px solid var(--color-grey-light);
										display: block;
										width: 100%;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-top: 8px;
										padding-bottom: 10px;

										&:focus{
											border-color: var(--color-blue);
										}
									}

									.small-text{
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-grey);
										font-family: var(--font-family-fira);
										font-size: 11px;
										line-height: 1.4em;
										padding: 0px 10px;
									}
								}

								.palco-ubicacion{
									margin-top: 10px;
									width: 100%;
									@include flex(row, flex-start, center);

									.palco-ubicacion-item{
										padding: 8px 22px 8px 12px;
										// border: 1px dashed var(--color-grey-medium);
										// background-color: #f3f3f9;
										border-right: 1px dashed var(--color-grey-medium);
										border-radius: 0px;
										@include flex(column, flex-start, flex-start);
										margin-right: 10px;

										&:last-child{
											border-right: none;
										}

										.palco-ubicacion-title{
											font-size: 14px;
											font-weight: var(--font-weight-regular);
											color: var(--color-grey);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											line-height: 16px;
											font-family: var(--font-family-fira);
										}

										.palco-ubicacion-valor{
											font-weight: var(--font-weight-bold);
											-webkit-letter-spacing: 0;
											-moz-letter-spacing: 0;
											-ms-letter-spacing: 0;
											letter-spacing: 0;
											color: var(--color-dark);
											font-family: var(--font-family-poppins);
											text-transform: uppercase;
										}
									}
								}

								.btn-preseleccion{
									@include flex(row, space-between, center);
									text-transform: uppercase;
									font-family: var(--font-family-poppins);
									font-weight: var(--font-weight-bold);
									position: relative;
									cursor: pointer;
									background-color: transparent;
									color: var(--color-dark);
									-webkit-transition: background-color .2s ease;
									transition: background-color .2s ease;
									-webkit-letter-spacing: 0.3px;
									-moz-letter-spacing: 0.3px;
									-ms-letter-spacing: 0.3px;
									letter-spacing: 0.3px;
									padding: 4px 10px;
									font-size: 11px;
									-webkit-font-smoothing: antialiased;
									-moz-osx-font-smoothing: grayscale;
									outline-color: transparent;
									outline: none;
									box-shadow: none;
									border: 0;
									margin: 0;
									margin-bottom: 15px;
									border-radius: 99px;
									border: 1px solid #d3d3dc;

									&:hover{
										background-color: var(--color-blue);
										border-color: var(--color-blue);
										color: var(--color-white);
									}

									svg{
										margin-right: 7px;
										width: 15px;
										height: auto;
										margin-top: -2px;
									}
								}

								.cancelar-ticket{
									@include flex(row, flex-start, center);
									border-radius: 4px;
									border: 1px solid var(--color-red);
									padding: 4px 8px;
									font-family: var(--font-family-poppins);
									font-size: 11px;
									font-weight: var(--font-weight-bold);
									color: var(--color-red);
									text-transform: uppercase;
									letter-spacing: 0.3px;
									line-height: 1em;
									transition: all .2s;
									cursor: pointer;

									svg{
										width: 17px;
										height: 17px;
										margin-right: 8px;
										color: var(--color-red);
									}

									&:hover{
										background-color: var(--color-red);
										color: var(--color-white);

										svg{
											color: var(--color-white);
										}
									}

									&.cancelando{
										color: var(--color-grey);
										border-color: var(--color-grey);
										cursor: auto;

										svg{
											color: var(--color-grey);
										}

										&:hover{
											background-color: var(--color-white);
											color: var(--color-grey);

											svg{
												color: var(--color-grey);
											}
										}
									}
								}
							}

							.ticket-num{
								font-weight: var(--font-weight-bold);
								font-family: var(--font-family-poppins);
								font-size: 12px;
								-webkit-letter-spacing: 0;
								-moz-letter-spacing: 0;
								-ms-letter-spacing: 0;
								letter-spacing: 0;
								padding: 2px 9px;
								border-radius: 22px;
								background-color: transparent;
								border: 1px solid var(--color-blue);
								color: var(--color-blue);
								letter-spacing: 1px;
								transition: all .2s;
							}
						}
					}

					.tickets-canjear{
						position: sticky;
						bottom: 0px;

						button.btn{
							width: 100%;
							@include flex(row, center, center);
							text-transform: uppercase;
							font-family: var(--font-family-poppins);
							font-weight: var(--font-weight-bold);
							position: relative;
							cursor: pointer;
							width: 100%;
							background-color: var(--color-red);
							color: var(--color-white);
							-webkit-transition: background-color .2s ease;
							transition: background-color .2s ease;
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							min-height: 48px;
							padding: 0 24px;
							font-size: 16px;
							line-height: 25px;
							-webkit-font-smoothing: antialiased;
							-moz-osx-font-smoothing: grayscale;
							outline-color: transparent;
							outline: none;
							box-shadow: none;
							border: 0;
							margin: 0;
							margin-top: 32px;

							&:hover{
								background-color: var(--color-blue-dark);
							}
						}
					}

					.tickets-menores{
						margin-top: 30px;

						.tickets-menores-title{
							margin: 0;
							font-size: 18px;
							line-height: 26px;
							font-family: var(--font-family-fira);
							font-weight: bold;
							color: var(--color-dark);
						}
						
						.ticket{
							&:after{
								content: 'Menor';
								background-color: var(--color-blue-dark);
							}

							&:before{
								content: none;
								background-color: var(--color-blue);
							}
						}
					}

					.tickets-emitidos{
						margin-top: 30px;

						.tickets-emitidos-title{
							margin: 0;
							font-size: 18px;
							line-height: 26px;
							font-family: var(--font-family-fira);
							font-weight: bold;
							color: var(--color-dark);
						}

						.ticket{
							&:after{
								background-color: var(--color-grey-light);
								color: var(--color-blue-darker);
								height: 100%;
							}

							&:before{
								content: none;
							}

							&:hover{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
								}
							}

							.palco-row{
								@include flex(row, flex-start, center);

								.input-group{
									width: 40%;

									span{
										margin: 0;
										font-size: 16px;
										line-height: 25px;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										padding-left: 0;
										padding-top: 4px;
										padding-bottom: 5px;
									}
								}

								.descargar-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-blue);
									font-size: 13px;
									cursor: pointer;
									line-height: 25px;
									font-weight: var(--font-weight-bold);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-poppins);
									text-transform: uppercase;
									text-decoration: none;
									transition: all .2s;

									svg{
										height: auto;
										width: 18px;
										margin-bottom: 4px;
									}

									&:hover{
										opacity: 0.8;
									}
								}

								.generando-ticket{
									width: 20%;
									@include flex(column, center, center);
									color: var(--color-grey);
									font-size: 12px;
									line-height: 18px;
									font-weight: var(--font-weight-regular);
									-webkit-letter-spacing: 0;
									-moz-letter-spacing: 0;
									-ms-letter-spacing: 0;
									letter-spacing: 0;
									font-family: var(--font-family-fira);
									text-decoration: none;
									text-align: center;
									transition: all .2s;

									svg{
										height: auto;
										width: 24px;
										margin-bottom: 6px;
										-webkit-animation: rotating 2s linear infinite;
										-moz-animation: rotating 2s linear infinite;
										-ms-animation: rotating 2s linear infinite;
										-o-animation: rotating 2s linear infinite;
										animation: rotating 2s linear infinite;
									}
								}

								.palco-ubicacion{
									padding-top: 10px;
									border-top: 1px solid var(--color-grey-light);
									width: 100%;
								}
							}
						}
					}

					.archivos-content{
						width: 100%;
						@include flex(column, flex-start, flex-start);

						span.title{
							margin: 0;
							font-size: 13px;
							line-height: 20px;
							margin-bottom: 2px;
							font-weight: var(--font-weight-bold);
							-webkit-letter-spacing: 0;
							-moz-letter-spacing: 0;
							-ms-letter-spacing: 0;
							letter-spacing: 0;
							color: var(--color-dark);
							font-family: var(--font-family-poppins);
							text-transform: uppercase;
						}

						.archivos{
							width: 100%;
							@include flex(row, flex-start, center);
							flex-wrap: wrap;

							&.esconder-archivos{
								.archivo{
									display: none;
								}
							}

							.archivo{
								@include flex(row, flex-start, center);
								border: 1px solid #d3d3dc;
								padding: 8px;
								border-radius: 4px;
								margin-right: 10px;
								margin-bottom: 10px;
								cursor: pointer;
								transition: all .2s;

								.archivo-left{
									@include flex(column, center, center);
									margin-right: 8px;

									img{
										height: 28px;
										width: auto;
									}
								}

								.archivo-right{
									@include flex(column, center, flex-start);

									span.archivo-nombre{
										font-size: 13px;
										line-height: 1em;
										font-weight: var(--font-weight-bold);
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										font-family: var(--font-family-poppins);
										text-transform: uppercase;
										margin-bottom: 2px;
									}

									span.archivo-extension{
										font-size: 10px;
										line-height: 1em;
										-webkit-letter-spacing: 0;
										-moz-letter-spacing: 0;
										-ms-letter-spacing: 0;
										letter-spacing: 0;
										color: var(--color-dark);
										text-transform: uppercase;
									}
								}

								&:hover{
									border-color: var(--color-blue);

									.archivo-right{
										span.archivo-nombre{
											color: var(--color-blue);
										}
									}
								}
							}

							.archivo-descargando{
								width: 100%;
								@include flex(row, center, center);
								padding: 10px;
								margin-bottom: 10px;
								border: 1px dashed #ddd;

								.v-spinner{
									@include flex(row, center, center);
								}
							}
						}
					}
				}
			}
		}
	}

	/* Responsive */
	@media screen and(max-width: 910px){
		.palco-page{
			.palco-header{
				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 24px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 32px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							font-size: 18px;
							margin-left: 8px;
							margin-top: 3px;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 28px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}

			.palco-main{
				margin: 30px 0;
				.container{
					@include flex(column, flex-start, flex-start);

					.palco-left{
						width: 100%;
					}

					.palco-right{
						margin-top: 30px;
						position: relative;
						top: auto;
						width: 100%;
					}
				}
			}
		}
	}

	@media screen and(max-width: 590px){
		.palco-page{
			.palco-main{
				.container{
					 .palco-left{
						  .tickets{
							   .ticket{
								   padding-left: 60px;

								    .palco-row{
										.input-group{
											label{
												font-size: 14px;
												line-height: 17px;
											}

											input{
												font-size: 14px;
												line-height: 20px;
											}
										}

										.palco-ubicacion{
											.palco-ubicacion-item{
												padding: 4px 10px 4px 0px;

												.palco-ubicacion-title{
													font-size: 13px;
													line-height: 15px;
												}

												.palco-ubicacion-valor{
													font-size: 14px;
													line-height: 1.4em;
												}
											}
										}
									}

									&:after{
										width: 40px;
										height: calc(100% - 40px);
									}

									&:before{
										width: 40px;
										height: 40px;
										font-size: 13px;
									}
							   }
						  }
						  .tickets-canjear button.btn{
							  min-height: 40px;
							  margin-top: 20px;
							  font-size: 14px;
						  }
						  .tickets-emitidos{
							.ticket{
								&:after{
									background-color: var(--color-grey-light);
									color: var(--color-blue-darker);
									height: 100%;
								}

								&:before{
									content: none;
								}

								&:hover{
									&:after{
										background-color: var(--color-grey-light);
										color: var(--color-blue-darker);
									}
								}

								 .palco-row{
									.input-group{
										width: 80%;
										label{
											font-size: 13px;
											line-height: 16px;
										}

										span{
											font-size: 13px;
											line-height: 18px;
										}
									}

									.descargar-ticket, .generando-ticket{
										position: absolute;
										top: 20px;
										right: 20px;
										font-size: 11px;
									}

									.palco-ubicacion{
										.palco-ubicacion-item{
											padding: 3px 10px 3px 0px;

											.palco-ubicacion-title{
												font-size: 12px;
												line-height: 14px;
											}

											.palco-ubicacion-valor{
												font-size: 13px;
												line-height: 1.3em;
											}
										}
									}
								 }
							}
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 510px){
		.palco-page{
			.palco-main{
				.container{
					 .palco-left{
						  .tickets{
							   .ticket{
								    .palco-row{
										@include flex(column, flex-start, flex-start);

										.input-group{
											width: 100%;
											padding: 0px;
											padding-bottom: 5px;
										}

										.palco-ubicacion{
											flex-wrap: wrap;
										}
									}
							   }
						  }
					 }
				}
			}
		}
	}

	@media screen and(max-width: 490px){
		.palco-page{
			.palco-header{
				height: 250px;

				.container{
					.header-row{
						&:last-child{
							margin: 0px;
						}

						.header-tipo{
							span{
								font-size: 10px;
								padding: 2px 6px;
								border-radius: 3px;
							}
						}

						.header-equipos .header-equipo.header-equipo-local span{
							font-size: 20px;
						}

						.header-equipos .header-equipo.header-equipo-local .header-escudo{
							height: 30px;
						}

						.header-equipos .header-equipo.header-equipo-local span.vs{
							display: none;
						}

						.header-equipos .header-equipo.header-equipo-visitante .header-escudo{
							height: 26px;
						}

						.header-equipos .header-equipo.header-equipo-visitante span{
							font-size: 20px;
						}
					}
				}
			}
		}
	}

	@-webkit-keyframes rotating {
		from {
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
	@keyframes rotating {
		from {
			-ms-transform: rotate(0deg);
			-moz-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
			-o-transform: rotate(0deg);
			transform: rotate(0deg);
		}
		to {
			-ms-transform: rotate(360deg);
			-moz-transform: rotate(360deg);
			-webkit-transform: rotate(360deg);
			-o-transform: rotate(360deg);
			transform: rotate(360deg);
		}
	}
</style>